import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import VendorUpload from "../../../CommonComponents/VendorUpload/VendorUpload";
import CommonInput from "../../../CommonComponents/CommonInput";
import CustomSelect from "../../../CommonComponents/Select/CustomSelect";
import { ArrowDropDown } from "@mui/icons-material";

const labelStyles = {
  marginBottom: "1rem",
  color: "#3a3a3a",
  fontSize: "1.25rem",
  fontWeight: 500,
};

const dropdownStyles = {
  fontSize: "1.2rem",
  ".MuiSvgIcon-root ": {
    fontSize: "4rem",
    color: "#7C7C7C",
  },
  ".makeStyles-placeholder-1": {
    color: "#5E6366",
  },
  ".MuiPopover-root.MuiMenu-paper.Mui-focused": {
    borderRadius: "4px 4px 0 0",
  },
};

const menuProps = {
  PaperProps: {
    sx: {
      bgcolor: "#ebeef8",
      borderRadius: "0 0 4px 4px",
    },
  },
};

const formContents = [
  {
    name: "account",
    label: "Account No.",
    type: "input",
    placeholder: "Enter",
    required: true,
  },
  {
    name: "branch",
    label: "Branch Name",
    type: "input",
    placeholder: "Enter",
    required: true,
  },
  {
    name: "bank",
    label: "Bank Name",
    type: "input",
    placeholder: "Enter",
    required: true,
  },
  {
    name: "ifsc",
    label: "IFSC Code",
    type: "input",
    placeholder: "Enter",
    required: true,
  },
  {
    name: "payment",
    label: "Payment Method",
    type: "select",
    placeholder: "Select",
    required: true,
    options: ["NEFT", "Cheque"],
  },
];

function BankDetails({
  setIsBtn1Active,
  setIsBtn2Active,
  saveClicked,
  nextClicked,
  onSaveClick,
  onNextClick,
}) {
  const [details, setDetails] = useState({});

  const onChangeHandler = (e) => {
    const name = e?.target?.name;
    setDetails((prev) => ({
      ...prev,
      [name]: name === "cheque" ? e?.target?.files[0] : e?.target?.value,
    }));
  };

  useEffect(() => {
    if (saveClicked) onSaveClick();
    if (nextClicked) onNextClick();
  }, [saveClicked, nextClicked]);

  useEffect(() => {
    let { cheque, account, branch, bank, ifsc, payment } = details;
    if (cheque && account && branch && bank && ifsc && payment) {
      setIsBtn1Active(true);
      setIsBtn2Active(true);
    } else {
      setIsBtn1Active(false);
      setIsBtn2Active(false);
    }
  }, [details]);

  return (
    <Box>
      <Grid
        sx={{ height: details?.["cheque"] ? "fit-content" : "16rem" }}
        container
        columnSpacing={2}
        rowGap={2}
      >
        <Grid item lg={2.5} md={12} sm={12}>
          <VendorUpload
            name="cheque"
            header="Upload Doc"
            label="Upload Cancelled Cheque"
            required={true}
            truncateSize={20}
            textIconGap="2rem"
            uploadedDocuments={
              details?.cheque
                ? {
                    "Upload Cancelled Cheque": {
                      filename: details?.cheque?.name,
                      fileUrl: URL.createObjectURL(details?.cheque),
                    },
                  }
                : {}
            }
            onChangeHandler={onChangeHandler}
          />
        </Grid>
        <Grid item lg={9.5} md={12} sm={12}>
          {details?.cheque && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "18rem",
                background: "#CFCFCF",
                borderRadius: "5px",
                position: "relative",
                top: "-15px",
              }}
            >
              <img
                style={{ objectFit: "fill", width: "60%", height: "95%" }}
                src={URL.createObjectURL(details?.cheque)}
                alt="alternateImg"
              />
            </div>
          )}
        </Grid>
      </Grid>
      <Grid container columnSpacing={10} rowGap={2}>
        {formContents?.map((item) => {
          return (
            <Grid key={item?.label} item md={3}>
              {item?.type === "input" ? (
                <CommonInput
                  name={item?.name}
                  label={item?.label}
                  value={details[item?.name]}
                  placeholder={item?.placeholder}
                  padding={"0.8rem 1.25rem"}
                  backgroundColor={"#ebeef8"}
                  focusedStyles={{
                    background: "white",
                    border: "1px solid #5570F1",
                  }}
                  sx={{
                    border: details?.[item?.name]
                      ? "1px solid #5570F1"
                      : "1px solid #ebeef8",
                    input: {
                      "&::placeholder": {
                        textOverflow: "ellipsis !important",
                        color: "#5E6366",
                        opacity: 1,
                        fontSize: "1.2rem",
                      },
                      padding: "1rem",
                      fontSize: "1.2rem",
                    },
                  }}
                  removeBackGround={details?.[item?.name]}
                  onChange={onChangeHandler}
                  required={item?.required}
                />
              ) : (
                <CustomSelect
                  name={item?.name}
                  label={item?.label}
                  labelStyles={labelStyles}
                  afterSx={{
                    ...dropdownStyles,
                    background: details?.[item?.name] ? "white" : "#ebeef8",
                    border: `1px solid ${
                      details?.[item?.name] ? "#5570F1" : "#ebeef8"
                    }`,
                  }}
                  placeholder={item?.placeholder}
                  customSelectValue={details?.[item?.name]}
                  options={item?.options}
                  handleChange={onChangeHandler}
                  dropDownIcon={ArrowDropDown}
                  menuProps={menuProps}
                  required={item?.required}
                />
              )}
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}

export default BankDetails;
